<script lang="ts" setup>
import { useForm } from 'vee-validate'
import { nextTick, watch } from 'vue'
import Modal from '@/components/shared/Modal.vue'
import HeaderModal from '@/components/shared/HeaderModal.vue'
import Button from '@/components/shared/Button.vue'
import FieldText from '@/components/shared/Fields/FieldText.vue'

interface Props {
  open: boolean
  loading?: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
  confirm: [name: string]
}>()

const { handleSubmit, resetForm, meta } = useForm({
  initialValues: {
    searchName: '',
  },
})

const handleConfirm = handleSubmit((values) => {
  emit('confirm', values.searchName)
})

function handleClose() {
  emit('close')
}

watch(
  () => props.open,
  (newVal) => {
    if (!newVal) {
      nextTick(() => {
        resetForm()
      })
    }
  },
)
</script>

<template>
  <Modal :open="open" :loading="loading" :unmount="true" @close="handleClose">
    <template #header>
      <HeaderModal title="Save Search" icon="bookmark" @close="handleClose" />
    </template>

    <form @submit.prevent="handleConfirm">
      <p class="mb-4 text-sm text-gray-500 dark:text-gray-400">
        Give your search a name to quickly access it later.
      </p>
      <FieldText
        name="searchName"
        :initial-focus="true"
        type="text"
        placeholder="Enter a name for your search"
        :show-label="false"
        :validate="false"
      />
    </form>

    <template #footer>
      <div class="flex gap-3 justify-end">
        <Button type="secondary" size="md" @click="handleClose"> Cancel </Button>
        <Button
          type="primary"
          size="md"
          :disabled="!meta.valid || loading"
          @click="handleConfirm"
          :loading="loading"
        >
          Save
        </Button>
      </div>
    </template>
  </Modal>
</template>
